var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { TooltipApi } from "..";
var EventCardIcon = /** @class */ (function (_super) {
    __extends(EventCardIcon, _super);
    function EventCardIcon(props) {
        var _this = _super.call(this, props) || this;
        _this.eventCardIconWrapperClasses = _this.props.baseClass + (_this.props.modifiers ? " " + _this.props.modifiers : "");
        _this.tooltip = TooltipApi.getInstance().setMessage(_this.props.tooltip);
        return _this;
    }
    EventCardIcon.prototype.render = function () {
        return (React.createElement("div", __assign({ className: this.eventCardIconWrapperClasses }, this.tooltip), this.props.children));
    };
    return EventCardIcon;
}(React.Component));
export { EventCardIcon };
//# sourceMappingURL=EventCardIcon.js.map